import type { SVGProps } from 'react'
const SvgPasskey = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="passkey_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#passkey_svg__a)">
      <path d="M2.098 15.229v-2.262q0-.68.351-1.248.351-.57.934-.87 1.176-.585 2.393-.88a10.5 10.5 0 0 1 4.005-.183 4.07 4.07 0 0 0 .408 2.116 4.1 4.1 0 0 0 1.418 1.62v1.707zm12.25 2.138-1.151-1.152v-3.572a2.65 2.65 0 0 1-1.383-.95 2.6 2.6 0 0 1-.537-1.623q0-1.113.787-1.9a2.6 2.6 0 0 1 1.901-.787q1.114 0 1.9.788.787.788.787 1.902a2.55 2.55 0 0 1-.484 1.534 2.7 2.7 0 0 1-1.239.96l.955.96-1.151 1.152 1.151 1.152zM8.25 8.924a3.04 3.04 0 0 1-2.226-.926 3.04 3.04 0 0 1-.926-2.227q0-1.3.926-2.224a3.04 3.04 0 0 1 2.226-.924q1.3 0 2.226.925.926.926.926 2.223 0 1.301-.926 2.227a3.04 3.04 0 0 1-2.226.926m5.715 1.531a.74.74 0 0 0 .545-.222.74.74 0 0 0 .223-.546.74.74 0 0 0-.223-.545.74.74 0 0 0-.545-.223.74.74 0 0 0-.546.223.74.74 0 0 0-.222.545q0 .324.222.546t.546.222" />
    </g>
  </svg>
)
export default SvgPasskey
